export const tefColumnsRoles = [
  { text: 'Id', value: 'id' },
  { text: 'Código Comercio (MID)', value: 'store_code', align: 'center' },
  { text: 'Código Terminal (TID)', value: 'terminal_code', align: 'center' },
  { text: 'Tipo de transacción', value: 'transaction_type', align: 'center' },
  { text: 'Tipo credito', value: 'credit_type', align: 'center' },
  { text: 'N° Autorización', value: 'authorization_number', align: 'center' },
  { text: 'ID Transacción', value: 'hiopos_transaction_id', align: 'center' },
  { text: 'Monto total Transacción', value: 'total_amount', align: 'center' },
  { text: 'Fecha Transacción', value: 'transaction_datetime', align: 'center' },
  { text: 'Franquicia', value: 'acquirer_name', align: 'center' },
  { text: 'Cuotas', value: 'installments', align: 'center' },
  { text: 'Meses Gracia', value: 'grace_months', align: 'center' },
  { text: 'Detalle Transacción', value: 'DetalleTransaccion', align: 'center' },
  { text: 'JSON de datos procescados', value: 'transaction_data_json', align: 'center' },
  { text: 'XML Hiopos', value: 'hiopos_xml', align: 'center' },
]
